export default __webpack_public_path__ + "static/media/control.9f0ac469.svg";